import React from 'react'
import {connect} from 'react-redux';
import CustomerModel from '/app/src/model/Customer/model';
import ConversationSelector from '/app/src/model/Conversation/selector';
import CustomerSelector from '/app/src/model/Customer/selector';
import EmployeesSelector from '/app/src/model/Employee/selector';
import AssignedOverview from './Overview';
import AssignedOption from './Option';
import AssignedPrevious from './Previous';
import AssignedTicketInfo from './TicketInfo';
import TabIcon from '../TabIcon';
import {Flex, Tabs} from '/app/src/component'

class AssignedOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: 0,
            openedCurrentConversationSection: [],
        }
        this.onTabClick = this.onTabClick.bind(this);
    }

    onTabClick(index) {
        this.setState({
            selectedIndex: index
        })

        // we should get all the tickets for this
        if(index === 2){
            const customer = this.props.customer;
            if(!customer.getIn(['tickets', 'fetched']) && !customer.getIn(['tickets', 'fetching'])){
                this.props.dispatch(CustomerModel.readResolvedTicketsFromDB(CustomerSelector.getId(customer)));
            }
        }
    }

    componentWillReceiveProps(nextProps){
        const conversation = this.props.conversation;
        const nextConversation = nextProps.conversation;

        const customerId = conversation.getIn(['info', 'payload', 'customer_id']);
        const nextCustomerId = nextConversation.getIn(['info','payload', 'customer_id']);

        if(customerId !== nextCustomerId){
            this.setState({
                selectedIndex: 0
            })
        }

    }

    render(){
            // onclick={this.claimTicket}
        const customer = this.props.customer;
        const onlineCoworkers = this.props.onlineCoworkers;
        const room = this.props.room;
        const selectedIndex = this.state.selectedIndex;

        if(!customer)
            return <Flex grow column center>
                <p> {'Kunden ej funnen.'} </p>
            </Flex>

        let tab0H = <TabIcon svgSrc='/images/Customer_S.svg' active={selectedIndex} index={0} onClick={this.onTabClick}/>
        let tab1H = <TabIcon svgSrc='/images/Menu_Conversations_S.svg' active={selectedIndex} index={1} onClick={this.onTabClick}/>
        let tab2H = <TabIcon svgSrc='/images/Menu_History_S.svg' active={selectedIndex} index={2} onClick={this.onTabClick}/>
        let tab3H = <TabIcon svgSrc='/images/Options_S.svg' active={selectedIndex} index={3} onClick={this.onTabClick}/>
        let tab0 = <AssignedOverview customer={customer}/>
        let tab1 = <AssignedTicketInfo room={room} customer={customer}/>
        let tab2 = <AssignedPrevious customer={customer}/>
        let tab3 = <AssignedOption customer={customer} coworkers={onlineCoworkers} room={room}/>

        return (
            <Flex h='100%' w='100%'>
                <Tabs
                    active={this.state.selectedIndex}
                    header={[tab0H, tab1H, tab2H, tab3H]}
                    body={[tab0, tab1, tab2, tab3]}
                />
            </Flex>

        );
    }
}

function mapStateToProps(state, ownProps) {
    const room = ownProps.room
    const conversation = ConversationSelector.getByRoom(state, room);
    const customerId = ConversationSelector.getCustomerId(conversation);
    const customer = CustomerSelector.getById(state, customerId)
    const onlineCoworkers = EmployeesSelector.getOnlineCoworkers(state);
    return { conversation, customer, onlineCoworkers, room };
}

export default connect(mapStateToProps)(AssignedOptions);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/Assigned/index.js